export default __webpack_public_path__ + "static/media/Soon.1f7c6f60.svg";